<script setup lang="ts">
import AdvertisingBody from '~/pages/advertising_main/ui/AdvertisingBody.vue';
import AdvertisingLeftBanner from '~/entities/advertising/ui/AdvertisingLeftBanner.vue';
import {
  SEO_TITLE,
  SEO_DESCRIPTION,
  OG_TYPE,
  OG_SITE_NAME,
  getOgImageMeta,
} from '~/shared/lib/seo';
import { useOrigin } from '~/shared/lib/useOrigin';

const origin = useOrigin();
const title = SEO_TITLE.replace('%%TITLE%%', 'Реклама в журналах');
const canonicalUrl = origin + '/advertising_main';
useHead({
  title: title,
  link: [{ rel: 'canonical', href: canonicalUrl }],
  meta: [
    { name: 'description', content: SEO_DESCRIPTION },
    { property: 'og:type', content: OG_TYPE },
    { property: 'og:title', content: title },
    { property: 'og:description', content: SEO_DESCRIPTION },
    { property: 'og:site_name', content: OG_SITE_NAME },
    ...getOgImageMeta(origin),
  ],
});
</script>

<template>
  <div class="static__page">
    <PageHeader
      title="Реклама в журналах"
      subtitle="Издательский Дом Ту Би Пресс – ведущая компания в России на рынке СМИ о коммерческой недвижимости."
      :show-border-bottom="true"
    />
    <AdvertisingBody />
    <AdvertisingLeftBanner
      button-text="По вопросам размещения рекламы обращайтесь по почте или телефону"
    />
  </div>
</template>

<style scoped lang="scss"></style>
